import { isMeaningfulThought } from '@littlebird/ui-utils';

import { ModalityPreviewContent, ThoughtContent } from './modality-registry';
import {
  ReasoningStepType,
  type ReasoningStep as ReasoningStepT,
} from './reasoning.types';

export const StepPreviewContent = ({ step }: { step: ReasoningStepT }) => {
  if (step.type === ReasoningStepType.Thought) {
    if (!isMeaningfulThought(step.hiddenContent)) return null;
    return (
      <div className="mt-2">
        <ThoughtContent thought={step.hiddenContent.trim()} id={step.id} />
      </div>
    );
  }

  if (step.type === ReasoningStepType.Modality) {
    const modality = step.modality;
    if (!modality) return null;
    return (
      <ModalityPreviewContent
        modality={modality}
        isLiveTodo={step.isLiveTodo}
      />
    );
  }

  return null;
};
